export const extractParameters = (url) => {
  try {
    const urlObject = new URL(url);
    const matches = [...urlObject.pathname.matchAll(/(:+(.[A-z0-9]*))/gm)];
    return matches.map((m) => m[1]);
  } catch (e) {
    return [];
  }
};
